import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { ProductAddToWishlistComponent as OriginalComponent } from '../../shared/product-add-to-wishlist/product-add-to-wishlist.component';

@Component({
  selector: 'ish-lazy-product-add-to-wishlist',
  templateUrl: './lazy-product-add-to-wishlist.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyProductAddToWishlistComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/wishlists/shared/product-add-to-wishlist/product-add-to-wishlist.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() displayType: OriginalComponent['displayType'];

  @Input() cssClass: OriginalComponent['cssClass'];

  @Input() ariaHidden: OriginalComponent['ariaHidden'];


  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('wishlists').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../wishlists.module`).then(m => m.WishlistsModule);

    const { ProductAddToWishlistComponent: originalComponent } = await import('../../shared/product-add-to-wishlist/product-add-to-wishlist.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.displayType = this.displayType;
      
        this.component.instance.cssClass = this.cssClass;
      
        this.component.instance.ariaHidden = this.ariaHidden;
      

      
    }
  }

}
